import { createBuilderModule } from '../../register-builder/builder-module';
import { Video } from './Video';

export default createBuilderModule(Video, {
  name: 'Video',
  image: '',
  inputs: [
    {
      name: 'videoUrl',
      type: 'cloudinaryMediaLibrary',
      required: true,
    },
    {
      name: 'title',
      type: 'string',
      required: true,
      helperText:
        'This is what a screen reader will use to describe the video.',
    },
    {
      name: 'posterImageUrl',
      type: 'cloudinaryMediaLibrary',
    },
    {
      name: 'textTracks',
      type: 'list',
      subFields: [
        {
          name: 'textTrackUrl',
          type: 'cloudinaryMediaLibrary',
        },
        {
          name: 'type',
          type: 'string',
          enum: ['subtitles', 'captions'],
        },
        {
          name: 'label',
          type: 'string',
        },
        {
          name: 'language',
          type: 'string',
          helperText:
            'This must be a valid langauage tag like "en-US". Values can be validated with this tool: https://r12a.github.io/app-subtags/',
        },
        {
          name: 'default',
          type: 'boolean',
        },
      ],
    },
    {
      name: 'autoPlay',
      type: 'boolean',
      helperText:
        'Note: Enabling auto play also mutes the video in order for it to be allowed by browsers',
    },
    {
      name: 'loop',
      type: 'boolean',
    },
    {
      name: 'hideControls',
      type: 'boolean',
    },
    { name: 'playbackRate', type: 'number' },
  ],
});
